import { usdFormat } from "../../../../utils";
import { SubEventReportRow } from "./type";
import { ColDef } from "ag-grid-community";

const generateColDefs = (): ColDef<SubEventReportRow>[] => [
  {
    headerName: 'Organization Name',
    valueGetter: p => p.data?.organization_name,
    hide: true,
  },
  {
    headerName: 'Start Date',
    valueGetter: p => p.data?.start_date,
    hide: true,
    sort: 'desc',
  },
  {
    headerName: 'Sub-Event Name',
    valueGetter: p => p.data?.sub_event_name,
    pinned: 'left',
    cellStyle: params => {
      if (params.value === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Total Gross Sales',
    valueGetter: p => p.data?.total_gross_sales,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Gross Cash Sales',
    valueGetter: p => p.data?.gross_cash_sales,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Gross Credit Sales',
    valueGetter: params => params.data?.gross_credit_sales,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Gross RFID Sales',
    valueGetter: params => params.data?.gross_rfid_sales,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Gross Cash Balance Sales',
    valueGetter: params => params.data?.gross_cash_balance_sales,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Gross Promo Balance Sales',
    valueGetter: params => params.data?.gross_promo_balance_sales,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Gross Token Sales',
    valueGetter: params => params.data?.gross_token_sales,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Total Net Sales',
    valueGetter: params => params.data?.total_net_sales,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Net Deduction - Discounts',
    valueGetter: params => params.data?.total_discounts,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Net Deduction - Promo Codes',
    valueGetter: params => params.data?.total_promo_discounts,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Net Deduction - Refunds',
    valueGetter: params => params.data?.net_refunds,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Net Deduction - Taxes',
    valueGetter: params => params.data?.total_tax,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Net Deduction - Token Sales',
    valueGetter: params => params.data?.gross_token_sales,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Net Deduction - Promo Balance Sales',
    valueGetter: params => params.data?.net_promo_balance_sales,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Total Tips',
    valueGetter: params => params.data?.total_tips,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Credit Tips',
    valueGetter: params => params.data?.gross_credit_tips,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'RFID Tips',
    valueGetter: params => params.data?.gross_rfid_tips,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Cash Balance Tips',
    valueGetter: params => params.data?.gross_cash_balance_tips,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Promo Balance Tips',
    valueGetter: params => params.data?.gross_promo_balance_tips,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Total Service Fee',
    valueGetter: params => params.data?.total_digital_surcharge,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Total Refunds Value',
    valueGetter: params => params.data?.total_refunds,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: 'Total Merchant Processed',
    valueGetter: params => params.data?.merchant_processed,
    valueFormatter: params => usdFormat.format(params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: '# of Transactions - Cash',
    valueGetter: params => params.data?.cash_transaction_count,
    valueFormatter: params => (params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: '# of Transactions - Credit',
    valueGetter: params => params.data?.credit_transaction_count,
    valueFormatter: params => (params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: '# of Transactions - RFID',
    valueGetter: params => params.data?.rfid_transaction_count,
    valueFormatter: params => (params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: '# of Transactions - Cash Balance',
    valueGetter: params => params.data?.cash_balance_transaction_count,
    valueFormatter: params => (params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: '# of Transactions - Promo Balance',
    valueGetter: params => params.data?.promo_balance_transaction_count,
    valueFormatter: params => (params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
  {
    headerName: '# of Transactions - Tokens',
    valueGetter: params => params.data?.token_transaction_count,
    valueFormatter: params => (params.value ?? 0),
    cellStyle: params => {
      if (params.data?.sub_event_name === 'Total') {
        return { fontWeight: 'bold' };
      }
      return null;
    }
  },
];

export const colDefs: ColDef<SubEventReportRow>[] = generateColDefs();

/**
 * Groups raw reports_financial rows into sub-event buckets.
 * Each row's transaction_date is checked against all sub-event date ranges.
 * Rows that don't fall within any sub-event range are discarded.
 */
export const formatData = (data: any[], allEvents: any[]): SubEventReportRow[] => {
  if (!data) {
    return [];
  }

  // Build a lookup of all sub-events with their date ranges
  const subEventDefs: { id: string; name: string; start_date: string; end_date: string }[] = [];
  (allEvents || []).forEach((event: any) => {
    (event.sub_events || []).forEach((se: any) => {
      subEventDefs.push({
        id: se.id,
        name: se.name,
        start_date: se.start_date,
        end_date: se.end_date,
      });
    });
  });

  let totalRow: SubEventReportRow = {
    id: "total-row",
    sub_event_name: "Total",
    start_date: '',
    total_gross_sales: 0,
    gross_cash_sales: 0,
    gross_credit_sales: 0,
    gross_rfid_sales: 0,
    gross_cash_balance_sales: 0,
    gross_promo_balance_sales: 0,
    total_net_sales: 0,
    total_discounts: 0,
    total_refunds: 0,
    net_refunds: 0,
    total_tax: 0,
    total_tips: 0,
    gross_credit_tips: 0,
    gross_rfid_tips: 0,
    gross_cash_balance_tips: 0,
    gross_promo_balance_tips: 0,
    total_digital_surcharge: 0,
    gross_token_sales: 0,
    net_token_sales: 0,
    merchant_processed: 0,
    net_promo_balance_sales: 0,
    cash_transaction_count: 0,
    credit_transaction_count: 0,
    rfid_transaction_count: 0,
    cash_balance_transaction_count: 0,
    promo_balance_transaction_count: 0,
    token_transaction_count: 0,
    total_promo_discounts: 0,
    location_name: '',
    location_id: 0,
    organization_name: '',
  };

  const groupedRows: Record<string, SubEventReportRow> = {};

  data.forEach((curr) => {
    // Extract just the date portion from transaction_date (could be "YYYY-MM-DD" or a full timestamp)
    const txDate = typeof curr.transaction_date === 'string'
      ? curr.transaction_date.substring(0, 10)
      : '';

    // Find which sub-event(s) this transaction belongs to
    const matchedSubEvents = subEventDefs.filter(
      (se) => txDate >= se.start_date && txDate <= se.end_date
    );

    // Discard rows that don't match any sub-event
    if (matchedSubEvents.length === 0) return;

    const total_gross_sales = (curr.gross_cash_balance_sales + curr.gross_cash_sales + curr.gross_credit_sales + curr.gross_promo_balance_sales + curr.gross_rfid_sales + curr.gross_token_sales) / 100;
    const gross_cash_balance_sales = curr.gross_cash_balance_sales / 100;
    const gross_cash_sales = curr.gross_cash_sales / 100;
    const gross_credit_sales = curr.gross_credit_sales / 100;
    const gross_promo_balance_sales = curr.gross_promo_balance_sales / 100;
    const gross_rfid_sales = curr.gross_rfid_sales / 100;
    const net_refunds = curr.net_refunds / 100;
    const total_refunds = curr.total_refunds / 100;
    const total_tax = curr.total_tax / 100;
    const total_tips = curr.total_tips / 100;
    const total_digital_surcharge = curr.total_digital_surcharge / 100;
    const total_discounts = curr.total_discounts / 100;
    const total_promo_discounts = curr.total_promo_discounts / 100;
    const total_net_sales = ((curr.gross_cash_balance_sales + curr.gross_cash_sales + curr.gross_credit_sales + curr.gross_promo_balance_sales + curr.gross_rfid_sales + curr.gross_token_sales) / 100) -
      ((curr.gross_token_sales + curr.net_refunds + curr.net_promo_balance_sales + curr.total_discounts + curr.total_promo_discounts + curr.total_tax) / 100);
    const gross_cash_balance_tips = curr.gross_cash_balance_tips / 100;
    const gross_promo_balance_tips = curr.gross_promo_balance_tips / 100;
    const gross_credit_tips = curr.gross_credit_tips / 100;
    const gross_rfid_tips = curr.gross_rfid_tips / 100;
    const gross_token_sales = curr.gross_token_sales / 100;
    const net_token_sales = curr.net_token_sales / 100;
    const net_promo_balance_sales = curr.net_promo_balance_sales / 100;
    const cash_transaction_count = curr.cash_transaction_count;
    const credit_transaction_count = curr.credit_transaction_count;
    const rfid_transaction_count = curr.rfid_transaction_count;
    const cash_balance_transaction_count = curr.cash_balance_transaction_count;
    const promo_balance_transaction_count = curr.promo_balance_transaction_count;
    const token_transaction_count = curr.token_transaction_count;
    const merchant_processed = curr.merchant_processed / 100;

    // A transaction could match multiple sub-events if ranges overlap — attribute to each
    for (const se of matchedSubEvents) {
      const key = se.id;

      if (groupedRows[key]) {
        const row = groupedRows[key];
        row.total_gross_sales += total_gross_sales;
        row.gross_cash_balance_sales += gross_cash_balance_sales;
        row.gross_cash_sales += gross_cash_sales;
        row.gross_credit_sales += gross_credit_sales;
        row.gross_promo_balance_sales += gross_promo_balance_sales;
        row.net_promo_balance_sales += net_promo_balance_sales;
        row.gross_rfid_sales += gross_rfid_sales;
        row.total_tax += total_tax;
        row.total_tips += total_tips;
        row.total_digital_surcharge += total_digital_surcharge;
        row.total_discounts += total_discounts;
        row.total_promo_discounts += total_promo_discounts;
        row.total_net_sales += total_net_sales;
        row.merchant_processed += merchant_processed;
        row.net_refunds += net_refunds;
        row.total_refunds += total_refunds;
        row.gross_cash_balance_tips += gross_cash_balance_tips;
        row.gross_promo_balance_tips += gross_promo_balance_tips;
        row.gross_credit_tips += gross_credit_tips;
        row.gross_rfid_tips += gross_rfid_tips;
        row.gross_token_sales += gross_token_sales;
        row.net_token_sales += net_token_sales;
        row.cash_transaction_count += cash_transaction_count;
        row.credit_transaction_count += credit_transaction_count;
        row.rfid_transaction_count += rfid_transaction_count;
        row.cash_balance_transaction_count += cash_balance_transaction_count;
        row.promo_balance_transaction_count += promo_balance_transaction_count;
        row.token_transaction_count += token_transaction_count;
      } else {
        groupedRows[key] = {
          id: key,
          sub_event_name: `${se.name} (${se.start_date} - ${se.end_date})`,
          start_date: se.start_date,
          total_gross_sales,
          gross_cash_balance_sales,
          gross_cash_sales,
          gross_credit_sales,
          gross_promo_balance_sales,
          net_promo_balance_sales,
          gross_rfid_sales,
          net_refunds,
          total_refunds,
          total_tax,
          total_tips,
          merchant_processed,
          total_digital_surcharge,
          total_discounts,
          total_promo_discounts,
          total_net_sales,
          gross_cash_balance_tips,
          gross_promo_balance_tips,
          gross_credit_tips,
          gross_rfid_tips,
          gross_token_sales,
          net_token_sales,
          cash_transaction_count,
          credit_transaction_count,
          rfid_transaction_count,
          cash_balance_transaction_count,
          promo_balance_transaction_count,
          token_transaction_count,
          location_name: curr.location_name || '',
          location_id: curr.location_id || 0,
          organization_name: curr.organization_name || '',
        };
      }

      // Accumulate total row
      totalRow.total_gross_sales += total_gross_sales;
      totalRow.gross_cash_balance_sales += gross_cash_balance_sales;
      totalRow.gross_cash_sales += gross_cash_sales;
      totalRow.gross_credit_sales += gross_credit_sales;
      totalRow.gross_promo_balance_sales += gross_promo_balance_sales;
      totalRow.gross_rfid_sales += gross_rfid_sales;
      totalRow.total_tax += total_tax;
      totalRow.total_tips += total_tips;
      totalRow.total_digital_surcharge += total_digital_surcharge;
      totalRow.total_discounts += total_discounts;
      totalRow.total_promo_discounts += total_promo_discounts;
      totalRow.total_net_sales += total_net_sales;
      totalRow.gross_cash_balance_tips += gross_cash_balance_tips;
      totalRow.gross_promo_balance_tips += gross_promo_balance_tips;
      totalRow.gross_credit_tips += gross_credit_tips;
      totalRow.gross_rfid_tips += gross_rfid_tips;
      totalRow.gross_token_sales += gross_token_sales;
      totalRow.merchant_processed += merchant_processed;
      totalRow.net_token_sales += net_token_sales;
      totalRow.net_promo_balance_sales += net_promo_balance_sales;
      totalRow.net_refunds += net_refunds;
      totalRow.total_refunds += total_refunds;
      totalRow.cash_transaction_count += cash_transaction_count;
      totalRow.credit_transaction_count += credit_transaction_count;
      totalRow.rfid_transaction_count += rfid_transaction_count;
      totalRow.cash_balance_transaction_count += cash_balance_transaction_count;
      totalRow.promo_balance_transaction_count += promo_balance_transaction_count;
      totalRow.token_transaction_count += token_transaction_count;
    }
  });

  groupedRows[totalRow.id] = totalRow;

  return Object.values(groupedRows);
};
